import { useNavigate } from "react-router-dom";
import DashboardNavData from "./DashboardNavData.js";

const DashboardNav = () => {
    const navigate = useNavigate();

    return (
        <div className="nav">
            <div className="nav-logo">
                <img src="/images/logo-circle-white.png" alt="logo" />
            </div>
            <ul className="nav_list">
                {DashboardNavData.map((value, key) => {
                    return (
                        <li key={key} className="row"
                            onClick={() => navigate(value.link)}
                        >
                            <div className="title">{value.title}</div>
                        </li>
                    );
                })}
            </ul>
        </div >
    );
}

export default DashboardNav;